export interface DataEntity_Resolution_04_Interface {
    id: number,
    range_min:string,
    range_max:string,
    unit:string,
  }
  
  export function Empty_DataEntity_Resolution_04_Interface(): DataEntity_Resolution_04_Interface {
    return {
      id: 0,
      range_min:'',
      range_max:'',
      unit: '',
    }
  }
  